<script>
  /* eslint-disable import/no-mutable-exports,no-underscore-dangle */
  // eslint-disable-next-line import/no-extraneous-dependencies
  import EVENT from "../../enums/event";
  import { onMount } from "svelte";

  export let product;
  export let productVariantId;
  export let productImage;
  export let isInWishlist = false;
  export let fullURL = window.location.origin + product.url;

  function checkIfInWishlist() {
    Object.values(window.productsInWishlist).forEach(wishlistProduct => {
      if (wishlistProduct.id === product.id) {
        isInWishlist = true;
      }
    });
  }

  function addToWishlist() {
    window._swat.addToWishList({
      epi: productVariantId,
      du: fullURL,
      empi: product.id,
      iu: productImage
    }, () => {
      isInWishlist = true;
    });
  }

  function removeFromWishlist() {
    window._swat.removeFromWishList({
      epi: productVariantId,
      du: fullURL,
      empi: product.id,
      iu: productImage
    }, () => {
      isInWishlist = false;
    });
  }

  function toggleInWishlist() {
    // eslint-disable-next-line no-unused-expressions
    isInWishlist ? removeFromWishlist() : addToWishlist();
  }

  onMount(() => {
    let timesChecked = 0;

    const checkInterval = setInterval(() => {
      checkIfInWishlist();
      timesChecked++;

      if (timesChecked === 10 || isInWishlist) {
        clearInterval(checkInterval);
      }
    }, 500);
  });

  document.addEventListener(EVENT.WISHLIST.CONTENTS_LOADED, () => {
    checkIfInWishlist();
  });
</script>

<button
  class={`w-2.5 h-2.5 product_${product.id}`}
  class:swym-added={isInWishlist}
  data-product-id="{product.id}"
  data-product-url="{product.url}"
  on:click="{toggleInWishlist}"
  aria-label="My Wishlist"
>
  <svg version="1.1" viewBox="0 0 1.5399 1.3077" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(-6.0154 -166.48)" stroke-width=".070004" fill="currentColor">
      <path
        class="heart-fill invisible"
        d="m7.106 166.48 0.035002 0.0386 0.41428 0.45341-0.035983 0.0386-0.71985 0.77706-0.042003-0.0439-0.74205-0.77208 0.037592-0.0398 0.42934-0.45074 0.040603 0.0298 0.2754 0.20301zm-0.30655 0.37668 0.022051 0.19406-0.047828-0.0752z" />
      <path
        d="m7.106 166.48 0.035002 0.0386 0.41428 0.45341-0.035983 0.0386-0.71985 0.77706-0.042003-0.0439-0.74205-0.77208 0.037592-0.0398 0.42934-0.45074 0.040603 0.0298 0.2754 0.20301zm-0.30655 0.37668-0.034444-0.0253-0.26924-0.19825-0.32202 0.33827 0.62431 0.64942 0.60203-0.64942-0.30803-0.337z" />
    </g>
  </svg>
</button>
